import { DomRenderer } from "./DomRenderer";
import { AnimationRenderer } from "./AnimationRenderer";
var Renderer = /** @class */ (function () {
    function Renderer(stageSize) {
        this.domRenderer = new DomRenderer(stageSize);
        this.animationRenderer = new AnimationRenderer(stageSize);
    }
    /** 生成一个完整的弹幕DOM元素 */
    Renderer.prototype.render = function (dan) {
        var danmakuDom = this.domRenderer.createDom(dan);
        this.animationRenderer.addAnimation(dan, danmakuDom);
        return danmakuDom;
    };
    return Renderer;
}());
export { Renderer };
//# sourceMappingURL=Renderer.js.map